import * as R from 'ramda'
import * as React from 'react'
import * as ReactRouter from 'react-router-dom'
import * as ReactRedux from 'react-redux'

import * as Common from '@rushplay/common'

import * as Session from './session'
import { GameInfo } from './game-info'
import { GameInfoSeoContent } from './game-info-seo-content'
import { GameLauncher } from './game-launcher'
import { GameWrapper } from './game-wrapper'
import { SimilarGamesSection } from './similar-games-section'
import { useGameInfoUrlQuery } from './use-game-info-url-query'

function GameInfoPage() {
  const gameInfoQuery = useGameInfoUrlQuery()
  const params = ReactRouter.useParams()
  const authenticated = ReactRedux.useSelector(state =>
    Session.isAuthenticated(state.session)
  )

  if (R.includes(gameInfoQuery.mode, ['classic', 'blitz'])) {
    return (
      <GameWrapper>
        <GameLauncher mode={gameInfoQuery.mode} />
      </GameWrapper>
    )
  }

  return (
    <Common.Box
      flexBasis="0"
      flexGrow="1"
      flexShrink="1"
      overflowX="hidden"
      display="flex"
      flexDirection="column"
    >
      <GameInfo />
      <Common.Box
        py={2}
        px={{ lg: 1 }}
        minHeight="277px"
        display="flex"
        flexDirection="column"
      >
        <SimilarGamesSection />

        {!authenticated && (
          <GameInfoSeoContent
            translationKey={`game-info-page.seo-content.${params.gameId}`}
          />
        )}
      </Common.Box>
    </Common.Box>
  )
}

// for @loadable/components
export default GameInfoPage
